import { LegacyPortalSearchEventType } from "@spwn-portal/grpc/build";

type Output = LegacyPortalSearchEventType[];
type ConvertToLegacyPortalSearchEventType = (
  previousValue: LegacyPortalSearchEventType[],
  input: string
) => Output;

const LEGACY_PORTAL_SEARCH_EVENT_TYPE_VALUES = new Set(
  Object.values(LegacyPortalSearchEventType)
);

export const convertToLegacyPortalSearchEventType: ConvertToLegacyPortalSearchEventType =
  (previousValue, currentValue) => {
    const numberInput = Number(currentValue);
    if (!LEGACY_PORTAL_SEARCH_EVENT_TYPE_VALUES.has(numberInput))
      return previousValue;

    previousValue.push(numberInput);
    return previousValue;
  };
